module.exports = __webpack_public_path__ + "img/60.77cb8e34.jpg";